import React from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';
import { TextField } from '../common/FormFields';
import { Formik } from 'formik';
import * as actions from '../../redux/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userGroupValidationSchema } from './admin.constants';

export const AddOrganizationDialog = ({ addOrganization }) => {
  const initialValues = { name: '' };
  const [open, setOpen] = React.useState(false);
  const [user, setUser] = React.useState(initialValues);

  const handleSubmit = organization => {
    addOrganization(organization);
    setUser(initialValues);
    setOpen(false);
  };

  const handleOpen = formik => {
    setUser(initialValues);
    formik.resetForm();
    setOpen(true);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={user}
      validationSchema={userGroupValidationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          onClose={() => setOpen(false)}
          onOpen={() => handleOpen(formik)}
          open={open}
          trigger={<Button positive content="Add organization" icon="plus" labelPosition="left" />}
        >
          <Modal.Header>Add organization</Modal.Header>
          <Modal.Content>
            <Form widths="equal">
              <Form.Group>
                <TextField
                  name="name"
                  formik={formik}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  errorMessage={formik.errors.name}
                  label="Organization name"
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button type="submit" content="Create organization" onClick={formik.handleSubmit} positive />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  addOrganization: bindActionCreators(actions.admin.addUserGroup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddOrganizationDialog);
